export default String.raw`
{% unless customer.NewsletterSubscriber -%}
    <section class="newsletter">
        <div class="newsletter__container">
            <div class="newsletter__container-title">
                <svg>
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#mailbox-{{ settings.iconStyle }}'></use>
                </svg>
                <div>
                    <h3>{{ translations.JoinNewsletter }}</h3>
                    <p>{{ translations.JoinNewsletter2 }}</p>
                </div>
            </div>
            <div class="newsletter__container-content">
                <div class="newsletter__container-content-icons">
                    <div>
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#newspaper-{{ settings.iconStyle }}"></use>
                        </svg>
                        <span>
                            {{ translations.NewMagazines }}
                        </span>
                    </div>
                    <div>
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#percent-{{ settings.iconStyle }}"></use>
                        </svg>
                        <span>
                            {{ translations.UniqueOffers }}
                        </span>
                    </div>
                    <div>
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#truck-{{ settings.iconStyle }}"></use>
                        </svg>
                        <span>
                            {{ translations.DeliverySchedule }}
                        </span>
                    </div>
                    <div>
                        <svg>
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lightbulb-on-{{ settings.iconStyle }}"></use>
                        </svg>
                        <span>
                            {{ translations.InspirationsAndTips }}
                        </span>
                    </div>
                </div>
            </div>
            <form class="newsletter__container-form newsletter-form-js">
                <p class="newsletter__container-form-info">{{ translations.JoinNewsletter2 }}</p>
                <div class="newsletter__container-form-email">
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{ settings.iconStyle }}"></use>
                    </svg>
                    <input name="email" aria-label="{{ translations.EmailAddress }}" type="email" placeholder="{{translations.NewsletterInputPlaceholder}}" autocomplete="email" maxlength="192" required>
                </div>
                <div class="checkBoxes__container newsletter__container-form-buttons">
                    {% for tos in config.TOS.Consents.Newsletter -%}
                        {% if tos.Statement == false -%}
                        <div>
                            <input id="{{ tos.Id }}-{{forloop.index}}" type="checkbox" name="tos" value="{{ tos.Id }}" {% if tos.Required -%} required {% endif -%} >
                            <label tabindex="0" role="checkbox" for="{{ tos.Id }}-{{forloop.index}}" aria-labelledby="{{ tos.Id }}-{{forloop.index}}-text" aria-checked="false" aria-required="{% if tos.Required -%}true{% else -%}false{% endif -%}">
                                <span class="checkBoxes__checkIcon">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{ settings.iconStyle }}"></use>
                                    </svg>
                                </span>
                                <span id="{{ tos.Id }}-{{forloop.index}}-text">
                                    {% if tos.Required -%}<span style="color: #9E0000;">* </span>{% endif -%}{{ tos.Text }}
                                </span>
                            </label>
                            {% for channel in tos.Channels -%}
                                <input id="{{ channel.Key }}-{{forloop.index}}" type="hidden" name="channel" value="{{ channel.Key }}" >
                            {% endfor -%}
                        </div>
                        {% else -%}
                        <p>
                            {% for channel in tos.Channels -%}
                                <input id="{{ channel.Key }}-{{forloop.index}}" type="hidden" name="channel" value="{{ channel.Key }}" >
                            {% endfor -%}
                            <input id="{{ tos.Id }}-{{forloop.index}}" type="hidden" name="tos" value="{{ tos.Id }}" checked>
                            {{ tos.Text }}
                        </p>
                        {% endif -%}
                    {% endfor -%}
                    <button class="primary-action-button">
                        {{ translations.SaveMe }}
                    </button>
                </div>
            </form>
        </div>
    </section>
{% endunless -%}
`